<div class="rendition-delete-container">
  <div class="icon-container">
    <qr-icon [name]="ICON_WARNING" [color]="ICON_COLOR_WHITE"></qr-icon>
  </div>
  <p>
    ¿Está seguro que desea anular la rendición
    <b>“{{this.address}}”</b>? Esta acción es irreversible.
  </p>
</div>
